import React from 'react'

const Loyalty = () => {
  return (
    <div>Programas de fidelización</div>
  )
}

export { Loyalty }
